class Input extends React.Component {

    render() {
        var self = this,
            autoComplete = this.props.autoComplete || 'off',
            type = this.props.type || 'text',
            id   = this.props.id || uuid(),
            className = this.props.className || '',
            style = this.props.style || {},
            placeholder = this.props.placeholder || '',
            disabled = this.props.disabled || false,
            action = this.props.action,
            tabindex = this.props.tabindex || '';

        return (
            <div className={'input'+ (this.props.disabled ? '__disabled ' : '' )}>
                <input
                    autoComplete={autoComplete}
                    type={type}
                    value={this.props.value}
                    className={''+className}
                    id={id}
                    style={style}
                    onChange={e => { this.props.onChange(e.target.value); }}
                    onBlur={() => {
                        if (this.props.onBlur)
                            this.props.onBlur();
                    }}
                    placeholder={placeholder}
                    disabled={disabled}
                    tabIndex={tabindex}
                    onKeyDown={(e) => {
                        if (this.props.onKeyDown)
                            this.props.onKeyDown(e);
                    }} />

                { action &&
                    <div className='input__action'>
                        { action.icon &&
                            <i
                                className={'fa fa-'+action.icon}
                                onClick={() => { action.onClick() }} />
                        }
                    </div>
                }
            </div>
        );
    }
}

export default Input;



// WEBPACK FOOTER //
// ./ui_src/app/components/form/input/Input.react.jsx